export default __webpack_public_path__ + "static/media/splash.79dafca4.png";